export var EClientUINotificationType;
(function (EClientUINotificationType) {
    EClientUINotificationType[EClientUINotificationType["GroupChatMessage"] = 1] = "GroupChatMessage";
    EClientUINotificationType[EClientUINotificationType["FriendChatMessage"] = 2] = "FriendChatMessage";
    EClientUINotificationType[EClientUINotificationType["FriendPersonaState"] = 3] = "FriendPersonaState";
})(EClientUINotificationType || (EClientUINotificationType = {}));
